import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import {
  AccountCircleRounded,
  ChatRounded,
  PersonRounded,
  QuestionAnswerRounded,
  SupervisedUserCircleRounded,
  TrendingDownRounded,
  TrendingUpRounded,
} from "@mui/icons-material";

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: 16,
    backgroundColor: theme.palette.background.dark,
    borderRadius: 24,
  },
  card: {
    width: "100%",
    padding: 16,
    border: "1px solid #EDE7F6",
    backgroundColor: theme.palette.background.default,
    borderRadius: 12,
    boxShadow: "0 0 12px 1px rgba(191, 191, 191, 0.16)",
  },
}));

function Users({ users }) {
  const {
    total,
    roles,
    change: { total_pct, total_direction, roles_pct, roles_direction },
  } = users;
  const { classes } = useStyles();
  return (
    <Box className={classes.container}>
      <Box px={2} mb={1.5}>
        <Typography variant="h6">Users</Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item size={{ xs: 12, md: 4 }}>
          <Box className={classes.card}>
            <Box display={"flex"} alignItems={"center"} gap={1} mb={1}>
              <Box
                height={30}
                width={30}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{ background: "#EDE7F6", borderRadius: 1 }}>
                <SupervisedUserCircleRounded
                  sx={{ fontSize: 16, color: "#673AB7" }}
                />
              </Box>
              <Typography variant="body2" color={"text.secondary"}>
                Total Users
              </Typography>
            </Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={1}>
              <Typography variant="h4">{total}</Typography>
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"flex-end"}>
                <Box display={"flex"} alignItems={"center"} gap={0.5}>
                  {total_direction === "increase" ? (
                    <TrendingUpRounded
                      sx={{ fontSize: 16, color: "#1B5E20" }}
                    />
                  ) : (
                    <TrendingDownRounded
                      sx={{ fontSize: 16, color: "#B71C1C" }}
                    />
                  )}
                  <Typography
                    fontSize={13}
                    fontWeight={500}
                    sx={{
                      color:
                        total_direction === "increase" ? "#1B5E20" : "#B71C1C",
                    }}>
                    {Math.round(total_pct)}%
                  </Typography>
                </Box>
                <Typography variant="caption" color={"text.secondary"}>
                  WoW
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item size={{ xs: 12, md: 4 }}>
          <Box className={classes.card}>
            <Box display={"flex"} alignItems={"center"} gap={1} mb={1}>
              <Box
                height={30}
                width={30}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                sx={{ background: "#FCE4EC", borderRadius: 1 }}>
                <AccountCircleRounded sx={{ fontSize: 16, color: "#E91E63" }} />
              </Box>
              <Typography variant="body2" color={"text.secondary"}>
                Total Roles
              </Typography>
            </Box>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={1}>
              <Typography variant="h4">{roles}</Typography>
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"flex-end"}>
                <Box display={"flex"} alignItems={"center"} gap={0.5}>
                  {roles_direction === "increase" ? (
                    <TrendingUpRounded
                      sx={{ fontSize: 16, color: "#1B5E20" }}
                    />
                  ) : (
                    <TrendingDownRounded
                      sx={{ fontSize: 16, color: "#B71C1C" }}
                    />
                  )}
                  <Typography
                    fontSize={13}
                    fontWeight={500}
                    sx={{
                      color:
                        roles_direction === "increase" ? "#1B5E20" : "#B71C1C",
                    }}>
                    {Math.round(roles_pct)}%
                  </Typography>
                </Box>
                <Typography variant="caption" color={"text.secondary"}>
                  WoW
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Users;
